import React from 'react';
import { Route, Routes, Navigate, useLocation } from 'react-router-dom';
import '@fortawesome/fontawesome-free/css/all.min.css';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import Sidebar from './components/Sidebar';
import Header from './components/Header';
import PageSeo from './components/PageSeo';
import AdvertisementCarousel from './components/AdvertisementCarousel';
import TextBox from './components/TextBox';
import CheckboxExample from './components/CheckboxExample';
import RadioExample from './components/RadioExample';
import ButtonExample from './components/ButtonExample';
import AlertExample from './components/AlertExample';
import IframeExample from './components/IframeExample';
import NewWindowExample from './components/NewWindowExample';
import './App.css';
import NestedIframeExample from './components/NestedIframeExample';
import MouseActionsExample from './components/MouseActionsExample';
import ScrollExample from './components/ScrollExample';
import TableExample from './components/TableExample';
import DropdownExample from './components/DropdownExample';
import SwipeGalleryExample from './components/swipeRightExample';
import WeblinksExample from './components/WeblinksExample';
import ForgetPassword from './components/ForgetpasswordExample';
import CalendarHeader from './components/CalendarHeader';
import SignUpExample from './components/SignUpExample';
import PracticeHome from './components/PracticeHome';
import NotFoundPage from './components/NotFoundPage';
import RelativeLocatorsExample from './components/RelativeLocatorsExample';
import SynchronizationExample from './components/SynchronizationExample';
import JavascriptExecutorExample from './components/JavascriptExecutorExample';
import DownloadFileExample from './components/DownloadFileExample';
import GenericExample from './components/GenericExample';

function App() {
  const { pathname } = useLocation();
  const showCourseAd = pathname !== '/' && pathname !== '/swipe' && pathname !== '/scroll';
  const isPlainContentPage = pathname === '/scroll';

  return (
    <div className="app">
      <PageSeo />
      <Header />
      <div className="app-body">
        <Sidebar />
        <div className="main-area">
          <div className={`content${isPlainContentPage ? ' content--plain' : ''}`} id="main-content-scroll">
          <div className={`left-content${isPlainContentPage ? ' left-content--plain' : ''}`}>
            <Routes>
              <Route path="/" element={<PracticeHome />} />
              <Route path="/text-box" element={<TextBox />} />
              <Route path="/checkbox" element={<CheckboxExample />} />
              <Route path="/radio-button" element={<RadioExample />} />
              <Route path="/button" element={<ButtonExample />} />
              <Route path="/java-script-alert" element={<AlertExample />} />
              <Route path="/javascript-alert" element={<Navigate to="/java-script-alert" replace />} />
              <Route path="/iframe" element={<IframeExample />} />
              <Route path="/nested-iframe" element={<NestedIframeExample />} />
              <Route path="/multiple-windows" element={<NewWindowExample />} />
              <Route path="/mouse-actions" element={<MouseActionsExample />} />
              <Route path="/double-click" element={<Navigate to="/mouse-actions" replace />} />
              <Route path="/mouse-hover" element={<Navigate to="/mouse-actions" replace />} />
              <Route path="/mouse-over" element={<Navigate to="/mouse-actions" replace />} />
              <Route path="/drag-and-drop" element={<Navigate to="/mouse-actions" replace />} />
              <Route path="/scroll" element={<ScrollExample />} />
              <Route path="/web-table" element={<TableExample />} />
              <Route path="/table" element={<Navigate to="/web-table" replace />} />
              <Route path="/drop-down" element={<DropdownExample />} />
              <Route path="/dropdown" element={<Navigate to="/drop-down" replace />} />
              <Route path="/swipe" element={<SwipeGalleryExample />} />
              <Route path="/web-links" element={<WeblinksExample />} />
              <Route path="/forgotpasswords" element={<ForgetPassword />} />
              <Route path="/verify-email" element={<ForgetPassword />} />
              <Route path="/calendar" element={<CalendarHeader />} />
              <Route path="/calander" element={<Navigate to="/calendar" replace />} />
              <Route path="/sign-up" element={<SignUpExample />} />
              <Route path="/relative-locators" element={<RelativeLocatorsExample />} />
              <Route path="/buttons-with-messages" element={<GenericExample />} />
              <Route path="/generic" element={<Navigate to="/buttons-with-messages" replace />} />
              <Route path="/css-selectors" element={<Navigate to="/buttons-with-messages" replace />} />
              <Route path="/css-locators" element={<Navigate to="/buttons-with-messages" replace />} />
              <Route path="/synchronization" element={<SynchronizationExample />} />
              <Route path="/javascript-executor" element={<JavascriptExecutorExample />} />
              <Route path="/download-file" element={<DownloadFileExample />} />
              <Route path="/browser-customization" element={<Navigate to="/download-file" replace />} />
              <Route path="/web/*" element={<Navigate to="/" replace />} />
              <Route path="*" element={<NotFoundPage />} />
            </Routes>
          </div>
          {showCourseAd && (
            <div className="right-advertisement">
              <AdvertisementCarousel />
            </div>
          )}
          </div>
        </div>
      </div>
    </div>
  );
}

export default App;
